import { render } from "./App.vue?vue&type=template&id=951b044e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=951b044e&lang=scss"

import exportComponent from "/codebuild/output/src4212162871/src/game-trivia-question/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__